import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LoginPage from "@/pages/LoginPage";
import Sidebar from "@/components/layout/Sidebar";
import ExecutiveDashboard from "@/pages/ExecutiveDashboard";
import PortfolioOverview from "@/pages/PortfolioOverview";
import Properties from "@/pages/Properties";
import Funds from "@/pages/Funds";
import Managers from "@/pages/Managers";
import SectorAnalytics from "@/pages/SectorAnalytics";
import GeographicAnalytics from "@/pages/GeographicAnalytics";
import Benchmarking from "@/pages/Benchmarking";
import RiskAnalytics from "@/pages/RiskAnalytics";
import Cashflow from "@/pages/Cashflow";
import DataManagement from "@/pages/DataManagement";
import { Skeleton } from "@/components/ui/skeleton";

function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="erp-layout" data-testid="app-layout">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <main className="erp-main bg-background">
        <Routes>
          <Route path="/" element={<ExecutiveDashboard />} />
          <Route path="/portfolio" element={<PortfolioOverview />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/funds" element={<Funds />} />
          <Route path="/managers" element={<Managers />} />
          <Route path="/sectors" element={<SectorAnalytics />} />
          <Route path="/geography" element={<GeographicAnalytics />} />
          <Route path="/benchmarks" element={<Benchmarking />} />
          <Route path="/risk" element={<RiskAnalytics />} />
          <Route path="/cashflow" element={<Cashflow />} />
          <Route path="/data" element={<DataManagement />} />
        </Routes>
      </main>
    </div>
  );
}

function AuthGate() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="space-y-4 w-64">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-4 w-3/4 mx-auto" />
        </div>
      </div>
    );
  }
  if (!isAuthenticated) return <LoginPage />;
  return <AppLayout />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AuthGate />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
